export const I18N_NAMESPACE = 'onyxAngular';
export const I18N_COUNTRY = 'country';

export const INTEGER_REGEXP = /^-?\d+$/;
